<app-si-dialog [hideHeader]="true" modalFooterClasses="si-dialog__footer--centered">
	<ng-template appDialogBody>
		<div class="px-16 py-8">
			<div class="flex items-center gap-5">
				<fa-icon class="text-primary-light shrink-0 mt-0.5" [icon]="['fal', 'circle-exclamation']" size="2x"></fa-icon>
				<p class="m-0">Your saved search filters cannot be combined with additional filters. Do you want to apply new filters or use your saved search filters?</p>
			</div>
		</div>
	</ng-template>

	<ng-template appDialogFooter>
		<button matButton="outlined" type="button" (click)="close()">Cancel</button>
		<button matButton="filled" type="button" (click)="newFilter()">New Filters</button>
		<button matButton="filled" type="button" (click)="useSavedSearch()">Use Saved Search</button>
	</ng-template>
</app-si-dialog>
